import React from 'react';
import { Link } from 'react-router-dom';
import { MappedMessage } from '../../../../global/components/messages/mapped-message-display';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { replaceAll } from '../../../../global/helpers/string-helpers';
import { InstitutionProps } from '../../models/arc-epi-props';

interface Props {
	institutionProps: InstitutionProps;
	name: string;
	officerUrl: string;
	tempPassword: string;
}

export function OfficerAddSuccess(props: Props) {
	const { institutionProps, name, officerUrl, tempPassword } = props;

	const successMessage = tempPassword ?
	    replaceAll(replaceAll(institutionProps?.officerAddSuccessMessages, '{name}', name), '{tempPassword}', tempPassword) :
		replaceAll(institutionProps?.officerAddSuccessNoPasswordMessages, '{name}', name);
	return (
		<>
			<MappedMessage message={institutionProps?.addOfficerSuccessBannerMessage} supplement={institutionProps?.addOfficerSuccessNextBestAction} />
			<WysiwygWithReactLink content={successMessage} />
			<Link to={officerUrl}>{institutionProps?.officersLinkText}</Link>

		</>
	);
}
